/**
 * Hero key figures — Section 03 of the approved IR content sheet.
 * Values are approved internal data / Company Profile wording; labels are
 * translation keys under `heroKeyFigures` in `app/localization/investor.json`.
 */
export type KeyFigureIcon =
  | "sectors"
  | "countries"
  | "years"
  | "facilities"
  | "revenue";

export type KeyFigure = {
  value: number;
  /**
   * Translation key for the text rendered right after the value, e.g. the `+`
   * in `50+`. Localised because the English `BN+` becomes a bare `+` in Arabic
   * — there the "billion" word lives in the label instead.
   */
  suffix?: string;
  label: string;
  icon: KeyFigureIcon;
};

export const keyFigures: KeyFigure[] = [
  { value: 4, label: "heroKeyFigures.coreSectors", icon: "sectors" },
  {
    value: 50,
    suffix: "heroKeyFigures.plus",
    label: "heroKeyFigures.countries",
    icon: "countries",
  },
  {
    value: 28,
    suffix: "heroKeyFigures.plus",
    label: "heroKeyFigures.yearsOfExperience",
    icon: "years",
  },
  {
    value: 20,
    label: "heroKeyFigures.manufacturingFacilities",
    icon: "facilities",
  },
  {
    value: 6,
    suffix: "heroKeyFigures.billionPlus",
    label: "heroKeyFigures.annualRevenue",
    icon: "revenue",
  },
];
